import React from 'react';
import { Box, Button, Divider, IconButton, Paper, TextField, Theme, useMediaQuery, useTheme } from '@mui/material';
import { Add, ArrowBack, Edit, Search } from '@mui/icons-material';

import { Environment } from '../../../environment';
import { useAuthContext } from '../../../context';

interface IToolsListingProps {
	textoDaBusca?: string;
	mostrarInputBusca?: boolean;
	aoMudarTextoBusca?: (novoTexto: string) => void;

	textoBotaoNovo?: string;
	showNewButton?: boolean;
	onClickNew?: () => void;

	textoBotaoEditar?: string;
	mostrarBotaoEditar?: boolean;
	aoClicarEmEditar?: () => void;

	mostrarBotaoBusca?: boolean;
	aoClicarEmBusca?: () => void;

	mostrarDivider?: boolean;

	showBackButton?: boolean,
}


export const ToolsListing: React.FC<IToolsListingProps> = ({
	textoDaBusca = '',
	mostrarInputBusca = false,
	aoMudarTextoBusca,

	textoBotaoNovo = 'Novo',
	showNewButton = false,
	onClickNew,

	mostrarBotaoBusca = false,
	aoClicarEmBusca,

	textoBotaoEditar = '',
	mostrarBotaoEditar = false,
	aoClicarEmEditar,

	mostrarDivider = true,

	showBackButton = false

}) => {

	function lastUrl() {
		window.history.back();
	}

	const theme = useTheme();
	const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

	return (
		<Box
			component={Paper}
			height={theme.spacing(4)}
			marginX={1}
			paddingX={2}
			padding={1}
			display={'flex'}
			gap={1}
			alignItems={'center'}
			borderRadius={2}

		>
			{mostrarInputBusca && (
				<TextField
					size='small'
					value={textoDaBusca}
					placeholder={Environment.INPUT_DE_BUSCA}
					onChange={(e) => aoMudarTextoBusca?.(e.target.value)}
					InputProps={{ sx: { borderRadius: '25px' } }}
				/>
			)}
			{mostrarBotaoBusca && (
				<IconButton
					onClick={aoClicarEmBusca}
				>
					<Search />
				</IconButton>
			)}

			{mostrarDivider && (
				<Divider
				/>
			)}
			{showNewButton && (
				<>
					{smDown ? <>
						<IconButton
							onClick={onClickNew}
						>
							<Add color='primary' />
						</IconButton>
					</> : <>
						<Button
							onClick={onClickNew}
							variant='contained'
							disableElevation
							endIcon={<Add />}
							sx={{ borderRadius: '25px' }}
						>
							{textoBotaoNovo}
						</Button>
					</>}
				</>
			)}
			<Box flex={1} display={'flex'} justifyContent={'end'} gap={1}>
				{mostrarBotaoEditar && (
					<>
						{smDown ? <>
							<IconButton
								onClick={aoClicarEmEditar}
							>
								<Edit color='primary' />
							</IconButton>
						</> : <>
							<Button
								onClick={aoClicarEmEditar}
								variant='contained'
								disableElevation
								endIcon={<Edit color='primary' />}
								sx={{ borderRadius: '25px' }}
							>
								{textoBotaoEditar}
							</Button>
						</>}
					</>
				)}
				{showBackButton && (
					<>
						{smDown ? <>
							<IconButton
								onClick={onClickNew}
							>
								<ArrowBack color='primary' />
							</IconButton>
						</> : <>
							<Button
								onClick={() => lastUrl()}
								variant='outlined'
								disableElevation
								endIcon={<ArrowBack />}
								sx={{ borderRadius: '25px' }}
							>
								Voltar
							</Button>
						</>}
					</>
				)}
			</Box>
		</Box>
	);
};